import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#a04e4e',
                concrete: '#f2f2f2',
                thunderbird: '#bd1b13',
                catskill: '#edf5f7',
                masala: '#474341',
            }
        }
    }
});
